export default __webpack_public_path__ + "static/cardImg1-e754d7d7ad79d41d0b1c2066f7a5495c.webp";